import * as auth from '../../app/modules/auth/redux/AuthRedux';

export default function setupAxios(axios: any, store: any) {
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: { accessToken },
      } = store.getState();

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }

      return config;
    },
    (err: any) => Promise.reject(err)
  );
  // Nuevo
  axios.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== '/auth/login'
      ) {
        alert('Sesión expirada, por favor inicie sesión de nuevo.');
        store.dispatch(auth.actions.logout());
        // window.location.href = '/auth/login';
      }
      return Promise.reject(error);
    }
  );
}
